import { isInChina } from "@/utils/commonUtils";
import { ZHONG_SHENG_DISTRIBUTOR_ID } from "@/utils/zhongShengConfig";
import zhCN from "@/locales/language/zh-CN";
import zhTW from "@/locales/language/zh-TW";
import enUS from "@/locales/language/en-US";
import msMY from "@/locales/language/ms-MY";
const LANGUAGE_FLAG = 'languageflag';
const QA_SEARCH_CONTENT = 'qasearchcontent';
const QA_CODE_CONTENT = 'qacodecontent';
const QA_DETAIL = 'qadetail';
const SCHEME_DETAIL = 'schemedetail';
const USER_INFO = 'user';
const CAMERA_INFO = 'camera';
const TOKEN_ACCESS = 'carAccess_token';
const TOKEN_REFRESH = 'refreshToken';
const DEALER_DETAIL = 'dealerdetail';
const QA_STEP_CONTENT = 'qastepcontent';

// 注册公司主体相关
const MAIN_BODY_DISTRIBUTOR = "mainbodydistributor";
const LOGIN_ROLE_SELECT = "loginroleselect";


// 出入库相关 
const STOCK_OUT_BATCH_CONTENT = 'stockoutbatchcontent';
const STOCK_OUT_BATCH_STATUS_CONTENT = 'stockoutbatchstatuscontent';
const STOCK_IN_BATCH_CONTENT = 'stockinbatchcontent';

const STOCK_IN_BATCH_STATUS_CONTENT = 'stockinbatchstatuscontent';

const STOCK_OUT_EACH_CONTENT = 'stockouteachcontent';

const STOCK_STOCK_CONTENT = "stockstockcontent";


const STOCK_RECORD_CONTENT = "stockrecordcontent";

const STOCK_IN_EACH_CONTENT = "stockineachcontent";


const STOCK_OUT_EACH_COUNT = "stockouteachcount";



const GO_SHOP_ORDER_DETAIL = "goshoporderdetail";


// 一些状态的保存处理  

const QA_REVIEW_TAB_STATUS = "qareviewstatus"; //质保审核页面的缓存处理 


const PURCHASE_ORDER_TAB_STATUS = "purchaseorderstatus"; //直营商的交易列表缓存处理  



const PURCHASE_ORDER_PAYMENT_TAB_STATUS = "purchaseorderpaymentstatus"; //付款单相关管理 




// 下订单时候的地址保存 
const PURCHASE_ORDER_ADDRESS = "purchaseorderaddress";




const STORE_INFO_LOCAL = "storelocalinfo";



// 供应商相关的
const STOCK_OUT_EACH_SUPPLIER_CONTENT = 'stockouteachsuppliercontent';



// pc 端的话背景选择

const PC_THEME_BG = 'pcthemebg';



// 选择的仓库 Id 
const SELECT_WAREHOUSE_ITEM = "selectedwarehouseitem";


// 选择的仓库状态
const WAREHOUSE_SHOW_FLAG = "warehouseshowflag";



export const saveLanguageFlag = flag => {
    localStorage.setItem(LANGUAGE_FLAG, flag ? flag : 'en-US');
}
export const getLanguageFlag = () => {

    return localStorage.getItem(LANGUAGE_FLAG) ? localStorage.getItem(LANGUAGE_FLAG) : isInChina() ? 'zh-CN' : 'en-US'
}

export const isInChinaCountry = () => {
    return isInChina();
}

export const savePcThemeBgFlag = flag => {
    localStorage.setItem(PC_THEME_BG, flag);
}
export const getPcThemeBgFlag = () => {
    return localStorage.getItem(PC_THEME_BG)
}




// 登录态保持
export const saveLoginAccessToken = (value = '') => {
    localStorage.setItem(TOKEN_ACCESS, value);
}
export const getLoginAccessToken = () => {
    const accessToken = localStorage.getItem(TOKEN_ACCESS)
    return accessToken
}

export const saveLoginRefreshToken = (value = '') => {
    localStorage.setItem(TOKEN_REFRESH, value);
}
export const getLoginRefreshToken = () => {
    const refreshToken = localStorage.getItem(TOKEN_REFRESH)
    return refreshToken
}
// 登录态保持



// 质保搜索的时候传递的参数
export const saveQaSearchContent = (value = '') => {
    sessionStorage.setItem(QA_SEARCH_CONTENT, value)
}
export const getQaSearchContent = () => {
    const content = sessionStorage.getItem(QA_SEARCH_CONTENT)
    return content ? content : ''
}



// 创建质保的时候 扫码获取卷芯号
export const saveQaCodeContent = (value = '') => {
    sessionStorage.setItem(QA_CODE_CONTENT, value)
}
export const getQaCodeContent = () => {
    const content = sessionStorage.getItem(QA_CODE_CONTENT)
    return content ? content : ''
}






// 质保现在页面拆分了 所以存在返回页面查看数据的情况 做个缓存
export const saveQaStepInfoContent = (value = '') => {
    sessionStorage.setItem(QA_STEP_CONTENT, JSON.stringify(value))
}
export const getQaStepInfoContent = () => {
    try {
        return JSON.parse(sessionStorage.getItem(QA_STEP_CONTENT))
    } catch (error) {
        return ''
    }
}

// Redesign 质保流程专用 session（与旧版 qastepcontent 隔离）
const QA_STEP_REDESIGN_CONTENT = 'qastepcontent_redesign';

export const saveQaStepRedesignContent = (value = '') => {
    sessionStorage.setItem(QA_STEP_REDESIGN_CONTENT, JSON.stringify(value))
}
export const getQaStepRedesignContent = () => {
    try {
        return JSON.parse(sessionStorage.getItem(QA_STEP_REDESIGN_CONTENT))
    } catch (error) {
        return ''
    }
}



// 出入库的批量扫码缓存处理
export const saveBatchStockOutContent = (value = '') => {
    sessionStorage.setItem(STOCK_OUT_BATCH_CONTENT, JSON.stringify(value))
}
export const getBatchStockOutContent = () => {
    try {
        return JSON.parse(sessionStorage.getItem(STOCK_OUT_BATCH_CONTENT))
    } catch (error) {
        return ''
    }
}

export const saveBatchStockOutStatusContent = (value = '') => {
    sessionStorage.setItem(STOCK_OUT_BATCH_STATUS_CONTENT, JSON.stringify(value))
}
export const getBatchStockOutStatusContent = () => {
    try {
        return JSON.parse(sessionStorage.getItem(STOCK_OUT_BATCH_STATUS_CONTENT))
    } catch (error) {
        return ''
    }
}





// 保存的只有序列号
export const saveBatchStockInContent = (value = '') => {
    sessionStorage.setItem(STOCK_IN_BATCH_CONTENT, JSON.stringify(value))
}
export const getBatchStockInContent = () => {
    try {
        return JSON.parse(sessionStorage.getItem(STOCK_IN_BATCH_CONTENT))
    } catch (error) {
        return ''
    }
}


// 对于上面的扩展，为了不影响到其他的代码 做的单独拓展
export const saveBatchStockInStatusContent = (value = '') => {
    sessionStorage.setItem(STOCK_IN_BATCH_STATUS_CONTENT, JSON.stringify(value))
}
export const getBatchStockInStatusContent = () => {
    try {
        return JSON.parse(sessionStorage.getItem(STOCK_IN_BATCH_STATUS_CONTENT))
    } catch (error) {
        return ''
    }
}



export const saveEachStockOutContent = (value = '') => {
    sessionStorage.setItem(STOCK_OUT_EACH_CONTENT, JSON.stringify(value))
}
export const getEachStockOutContent = () => {
    try {
        return JSON.parse(sessionStorage.getItem(STOCK_OUT_EACH_CONTENT))
    } catch (error) {
        return ''
    }
}



// 供应商相关
export const saveSupplierEachStockOutContent = (value = '') => {
    sessionStorage.setItem(STOCK_OUT_EACH_SUPPLIER_CONTENT, JSON.stringify(value))
}
export const getSupplierEachStockOutContent = () => {
    try {
        return JSON.parse(sessionStorage.getItem(STOCK_OUT_EACH_SUPPLIER_CONTENT))
    } catch (error) {
        return ''
    }
}
// 供应商相关


export const saveStockStockContent = (value = '') => {
    sessionStorage.setItem(STOCK_STOCK_CONTENT, JSON.stringify(value))
}
export const getStockStockContent = () => {
    try {
        return JSON.parse(sessionStorage.getItem(STOCK_STOCK_CONTENT))
    } catch (error) {
        return ''
    }
}



export const saveStockRecordContent = (value = '') => {
    sessionStorage.setItem(STOCK_RECORD_CONTENT, JSON.stringify(value))
}
export const getStockRecordContent = () => {
    try {
        return JSON.parse(sessionStorage.getItem(STOCK_RECORD_CONTENT))
    } catch (error) {
        return ''
    }
}


export const saveStockInEachContent = (value = '') => {
    sessionStorage.setItem(STOCK_IN_EACH_CONTENT, JSON.stringify(value))
}
export const getStockInEachContent = () => {
    try {
        return JSON.parse(sessionStorage.getItem(STOCK_IN_EACH_CONTENT))
    } catch (error) {
        return ''
    }
}




export const saveStockOutCountEachContent = (value = '') => {
    sessionStorage.setItem(STOCK_OUT_EACH_COUNT, JSON.stringify(value))
}
export const getStockOutCountEachContent = () => {
    try {
        return JSON.parse(sessionStorage.getItem(STOCK_OUT_EACH_COUNT))
    } catch (error) {
        return ''
    }
}



// 仓库相关 
export const saveWareHouseContent = (value = '') => {
    sessionStorage.setItem(SELECT_WAREHOUSE_ITEM, JSON.stringify(value))
}
export const getWareHouseContent = () => {
    try {
        return JSON.parse(sessionStorage.getItem(SELECT_WAREHOUSE_ITEM))
    } catch (error) {
        return ''
    }
}



// 仓库状态相关  当前只有一个的时候是不展示的 
export const saveWareHouseShowFlag = (value = false) => {
    sessionStorage.setItem(WAREHOUSE_SHOW_FLAG, JSON.stringify(Boolean(value)))
}
export const getWareHouseShowFlag = () => {
    const rawValue = sessionStorage.getItem(WAREHOUSE_SHOW_FLAG)
    if (rawValue == null) {
        return false
    }
    try {
        return Boolean(JSON.parse(rawValue))
    } catch (error) {
        return rawValue === 'true'
    }

}
















/**
 *  用户信息状态
 */
const saveToLocal = (key, value) => {
    localStorage[key] = JSON.stringify(value);
}
const getFromLocal = key => {
    try {
        return JSON.parse(localStorage[key])
    } catch (error) {
        return ''
    }
}

export const saveUserInfo = info => {
    saveToLocal(USER_INFO, info)
}
export const getUserInfo = () => {
    return getFromLocal(USER_INFO)
}

// 判断一下当前的零售商上级是否是中升
const findLevelOneDistributor = (distributor) => {
    if (!distributor) return null;
    let current = distributor;
    let guard = 0;
    while (current && guard < 20) {
        if (current.level == 1) {
            return current;
        }
        if (!current.directSuperiorDistributor) {
            return null;
        }
        current = current.directSuperiorDistributor;
        guard += 1;
    }
    return null;
};

export const isZhongShengRetailer = () => {
    const userInfo = getUserInfo();
    if (!userInfo || userInfo.userType !== 'RETAILER_USER') {
        return false;
    }
    const levelOneDistributor = findLevelOneDistributor(
        userInfo?.retailer?.directSuperiorDistributor
    );
    if (!levelOneDistributor?.id) {
        return false;
    }
    return ZHONG_SHENG_DISTRIBUTOR_ID.includes(String(levelOneDistributor.id));
};





// 是否是分销商用户
export const isDistributorUser = () => {
    const userInfo = getUserInfo();
    return userInfo ? userInfo.userType == 'DISTRIBUTOR_USER' : false
}
// 是否是零售商商用户
export const isRetailerUser = () => {
    const userInfo = getUserInfo();
    return userInfo ? userInfo.userType == 'RETAILER_USER' : false
}

// 是否是消费者
export const isIndividualUser = () => {
    const userInfo = getUserInfo();
    return userInfo ? userInfo.userType == 'INDIVIDUAL_USER' : false
}

// 是否是直营商
export const isDirectVendorUser = () => {
    const userInfo = getUserInfo();
    return userInfo ? userInfo.userType == 'DIRECT_VENDOR_USER' : false
}

// 是否是供应商
export const isSupplierUser = () => {
    const userInfo = getUserInfo();
    return userInfo ? userInfo.userType == 'SUPPLIER_USER' : false
}

// 是否是系统用户
export const isSystemUser = () => {
    const userInfo = getUserInfo();
    return userInfo ? userInfo.userType == 'SYSTEM_USER' : false
}




export const getDistributorName = () => {
    const userInfo = getUserInfo();

}
export const getUserCompanyName = () => {
    const userInfo = getUserInfo();
    // console.log('userInfo', userInfo)
    if (userInfo?.userType == 'DISTRIBUTOR_USER') {
        // 分销商
        return userInfo?.distributor?.fullName
    }
    if (userInfo?.userType == 'RETAILER_USER') {
        // 零售商
        return userInfo?.retailer?.fullName
    }
    if (userInfo?.userType == 'SERVICE_PROVIDER_USER') {
        // 服务商用户
        return userInfo?.serviceProvider?.fullName
    }
    if (userInfo?.userType == 'DIRECT_VENDOR_USER') {
        // 直营商用户
        return userInfo?.directVendor?.fullName

    }
    if (userInfo?.userType == 'SUPPLIER_USER') {
        // 供应商用户
        return userInfo?.supplier?.fullName

    }

    return "";
}

const LANG_APP_MESSAGES = {
    'zh-CN': zhCN,
    'zh-TW': zhTW,
    'en-US': enUS,
    'ms-MY': msMY,
};

const getRetailerTypeDesc = (isSalesOnly) => {
    const app = (LANG_APP_MESSAGES[getLanguageFlag()] || zhCN).app;
    return isSalesOnly
        ? app.dealershopmanager.type.sales_only_short
        : app.dealershopmanager.retailer;
};

export const getUserCompanyTypeDesc = () => {
    const userInfo = getUserInfo();
    // console.log('userInfo', userInfo)
    if (userInfo?.userType == 'DISTRIBUTOR_USER') {
        // 分销商
        return userInfo?.distributor?.merchantPartyTypeDescription
    }
    if (userInfo?.userType == 'RETAILER_USER') {
        // 零售商
        return getRetailerTypeDesc(userInfo?.retailer?.type == 'SALES_ONLY');
    }
    if (userInfo?.userType == 'SERVICE_PROVIDER_USER') {
        // 服务商用户
        return userInfo?.serviceProvider?.merchantPartyTypeDescription
    }
    if (userInfo?.userType == 'DIRECT_VENDOR_USER') {
        // 直营商用户
        return userInfo?.directVendor?.merchantPartyTypeDescription

    }
    if (userInfo?.userType == 'SUPPLIER_USER') {
        // 供应商用户
        return userInfo?.supplier?.merchantPartyTypeDescription

    }

    return "";
}



export const getUserType = () => {
    const userInfo = getUserInfo();
    return userInfo ? userInfo.userType : ''
}


// 获取当前的分销商信息 
export const getDistributorInfo = () => {
    const userInfo = getUserInfo();
    return userInfo?.distributor;
}

// 获取当前的分销商信息 
export const getDirectSuperiorDistributorInfo = () => {
    const userInfo = getUserInfo();
    if (userInfo?.userType == 'DISTRIBUTOR_USER') {
        // 分销商
        return userInfo?.distributor?.directSuperiorDistributor
    }
    if (userInfo?.userType == 'RETAILER_USER') {
        // 零售商
        return userInfo?.retailer?.directSuperiorDistributor
    }
    return '';
}


// 获取当前的零售商信息 
export const getRetailerInfo = () => {
    const userInfo = getUserInfo();
    return userInfo?.retailer;
}





// 是否是常规用户
export const isRegularUser = () => {
    const userInfo = getUserInfo();
    return userInfo ? userInfo.cfilmUserType == 'REGULAR_USER' : false
}

// 是否是经销商用户
export const isDealerUser = () => {
    const userInfo = getUserInfo();
    return userInfo ? userInfo.cfilmUserType == 'DEALER_USER' : false
}

//是否是一级分销商  (最新的版本)
export const isFirstLevelDistributor = () => {
    const userInfo = getUserInfo();
    return userInfo?.distributor?.level == '1';
}

//是否是下级分销商  (最新的版本)
export const isSubLevelDistributor = () => {
    const userInfo = getUserInfo();
    return userInfo?.distributor?.level > 1;
}

//是否是零售商端 (最新的版本)
export const isRetailer = () => {
    return isRetailerUser();
}




// 是否是一级经销商
export const isFirstLevelDealer = () => {
    const userInfo = getUserInfo();
    return userInfo ? userInfo.cfilmUserType == 'DEALER_USER' && userInfo.dealer?.level == 1 : false;
}

// 是否是二级经销商
export const isSecondaryLevelDealer = () => {
    const userInfo = getUserInfo();
    return userInfo ? userInfo.cfilmUserType == 'DEALER_USER' && userInfo.dealer?.level == 2 : false;
}


// 获取零售商ID
export const getRetailerId = () => {
    const userInfo = getUserInfo();
    return userInfo ? userInfo.retailerId : ''
}

// 获取分销商ID
export const getDistributorId = () => {
    const userInfo = getUserInfo();
    return userInfo ? userInfo.distributorId : ''
}
// 获取供应商ID
export const getSupplierId = () => {
    const userInfo = getUserInfo();
    return userInfo ? userInfo.supplierId : ''
}

// 获取直营商ID
export const getDirectVendorId = () => {
    const userInfo = getUserInfo();
    return userInfo ? userInfo.directVendorId : ''
}

// 获取个人消费者ID
export const getIndividualUserId = () => {
    const userInfo = getUserInfo();
    return userInfo ? userInfo.id : '';
}


// 获取用户ID
export const getUserId = () => {
    const userInfo = getUserInfo();
    return userInfo ? userInfo.cfilmUserId : ''
}

// 获取经销商ID
export const getDealerId = () => {
    const userInfo = getUserInfo();
    return userInfo ? userInfo.dealerId : ''
}

// 获取 fullName
export const getFullName = () => {
    const userInfo = getUserInfo();
    return userInfo ? userInfo.fullName : ''
}

// 获取用户手机号 
export const getPhoneNumber = () => {
    const userInfo = getUserInfo();
    return userInfo ? userInfo.phoneNumber : ''
}

// 获取用户手机号  只保留手机号  不保留国家代码
export const getSamplePhoneNumber = () => {
    const userInfo = getUserInfo();
    return userInfo ? formatChinesePhone(userInfo.phoneNumber) : ''
}

function formatChinesePhone(phone) {
    const array = phone.split(' ')
    return array.splice(1, array.length).join('')
}

// 是否是登录状态
export const isLogin = () => {
    return !!getFromLocal(USER_INFO)
}
/**
 *  用户信息状态
 */





/**                     质保详情信息                    **/
export const saveQaDetail = (value = '') => {
    sessionStorage.setItem(QA_DETAIL, JSON.stringify(value))
}
export const getQaDetail = () => {
    try {
        return JSON.parse(sessionStorage.getItem(QA_DETAIL))
    } catch (error) {
        return ''
    }
}
/**                     质保详情信息                   **/


/**                     代理商详情信息                    **/
export const saveDealerDetail = (value = '') => {
    sessionStorage.setItem(DEALER_DETAIL, JSON.stringify(value))
}
export const getDealerDetail = () => {
    try {
        return JSON.parse(sessionStorage.getItem(DEALER_DETAIL))
    } catch (error) {
        return ''
    }
}
/**                     代理商详情信息                   **/



/**                     scheme信息                    **/
export const saveSchemeDetail = (value = '') => {
    sessionStorage.setItem(SCHEME_DETAIL, JSON.stringify(value))
}
export const getSchemeDetail = () => {
    try {
        return JSON.parse(sessionStorage.getItem(SCHEME_DETAIL))
    } catch (error) {
        return ''
    }
}
/**                     scheme信息                   **/



/**                     扫码用户选择的摄像头                 **/
export const saveCameraContent = (value = '') => {
    localStorage.setItem(CAMERA_INFO, value)
}
export const getCameraContent = () => {
    const content = localStorage.getItem(CAMERA_INFO)
    return content ? content : ''
}
/**                     扫码用户选择的摄像头                   **/





/**                     主体相关                    **/
const REGISTER_ADDRESS_MAP_RESULT = 'register_address_map_result';

export const saveMainBodyDetail = (value = '') => {
    sessionStorage.setItem(MAIN_BODY_DISTRIBUTOR, JSON.stringify(value))
}
export const getMainBodyDetail = () => {
    try {
        return JSON.parse(sessionStorage.getItem(MAIN_BODY_DISTRIBUTOR))
    } catch (error) {
        return ''
    }
}

export const saveRegisterAddressMapResult = (value = {}) => {
    sessionStorage.setItem(REGISTER_ADDRESS_MAP_RESULT, JSON.stringify(value))
}

export const consumeRegisterAddressMapResult = () => {
    try {
        const raw = sessionStorage.getItem(REGISTER_ADDRESS_MAP_RESULT)
        sessionStorage.removeItem(REGISTER_ADDRESS_MAP_RESULT)
        return raw ? JSON.parse(raw) : null
    } catch (error) {
        return null
    }
}


export const saveLoginRoleSelectDetail = (value = '') => {
    sessionStorage.setItem(LOGIN_ROLE_SELECT, JSON.stringify(value))
}
export const getLoginRoleSelectDetail = () => {
    try {
        return JSON.parse(sessionStorage.getItem(LOGIN_ROLE_SELECT))
    } catch (error) {
        return ''
    }
}


/**                     主体相关                  **/





/**                     采购单相关                  **/
export const saveShopOrderDetail = (value = '') => {
    sessionStorage.setItem(GO_SHOP_ORDER_DETAIL, JSON.stringify(value))
}
export const getShopOrderDetail = () => {
    try {
        return JSON.parse(sessionStorage.getItem(GO_SHOP_ORDER_DETAIL))
    } catch (error) {
        return ''
    }
}

/**                     采购单相关                  **/





/**                     一些界面的缓存处理方案                **/
export const saveQaReviewTabStatus = (value = '') => {
    sessionStorage.setItem(QA_REVIEW_TAB_STATUS, JSON.stringify(value))
}
export const getQaReviewTabStatus = () => {
    try {
        return JSON.parse(sessionStorage.getItem(QA_REVIEW_TAB_STATUS))
    } catch (error) {
        return ''
    }
}


export const savePurchaseOrderTabStatus = (value = '') => {
    sessionStorage.setItem(PURCHASE_ORDER_TAB_STATUS, JSON.stringify(value))
}
export const getPurchaseOrderTabStatus = () => {
    try {
        return JSON.parse(sessionStorage.getItem(PURCHASE_ORDER_TAB_STATUS))
    } catch (error) {
        return ''
    }
}



// 关于付款单方面的
export const savePurchaseOrderPaymentTabStatus = (value = '') => {
    sessionStorage.setItem(PURCHASE_ORDER_PAYMENT_TAB_STATUS, JSON.stringify(value))
}
export const getPurchaseOrderPaymentTabStatus = () => {
    try {
        return JSON.parse(sessionStorage.getItem(PURCHASE_ORDER_PAYMENT_TAB_STATUS))
    } catch (error) {
        return ''
    }
}
// 关于付款单方面的





// 
export const saveOrderAddressStatus = (value = '') => {
    sessionStorage.setItem(PURCHASE_ORDER_ADDRESS, JSON.stringify(value))
}
export const getOrderAddressStatus = () => {
    try {
        return JSON.parse(sessionStorage.getItem(PURCHASE_ORDER_ADDRESS))
    } catch (error) {
        return ''
    }
}



// 点击店铺以后 再订单详情页面展示的信息
export const saveSelectStoreInfo = (value = '') => {
    sessionStorage.setItem(STORE_INFO_LOCAL, JSON.stringify(value))
}
export const getSelectStoreInfo = () => {
    try {
        return JSON.parse(sessionStorage.getItem(STORE_INFO_LOCAL))
    } catch (error) {
        return ''
    }
}


// 消费者在本站选择商品后，把购物车数据透传给 /consumer/orderdetail（官网来源走 redis 接口，本地来源走这里）
const CONSUMER_LOCAL_CART = "consumerlocalcart";

export const saveConsumerLocalCart = (value = {}) => {
    sessionStorage.setItem(CONSUMER_LOCAL_CART, JSON.stringify(value))
}
export const getConsumerLocalCart = () => {
    try {
        return JSON.parse(sessionStorage.getItem(CONSUMER_LOCAL_CART))
    } catch (error) {
        return null
    }
}
export const clearConsumerLocalCart = () => {
    sessionStorage.removeItem(CONSUMER_LOCAL_CART)
}




/**                     一些界面的缓存处理方案                   **/










// 退出登录
export const logout = () => {
    localStorage.removeItem(TOKEN_ACCESS);
    localStorage.removeItem(TOKEN_REFRESH);
    localStorage.removeItem(USER_INFO);
    sessionStorage.removeItem(QA_SEARCH_CONTENT);
    sessionStorage.removeItem(QA_CODE_CONTENT);
    sessionStorage.removeItem(QA_DETAIL);
    sessionStorage.removeItem(SCHEME_DETAIL);
    sessionStorage.removeItem(CAMERA_INFO);
    sessionStorage.removeItem(DEALER_DETAIL);
    sessionStorage.removeItem(QA_STEP_CONTENT);

    sessionStorage.removeItem(MAIN_BODY_DISTRIBUTOR);

    sessionStorage.removeItem(LOGIN_ROLE_SELECT);

    sessionStorage.removeItem(STOCK_OUT_BATCH_CONTENT);
    sessionStorage.removeItem(STOCK_OUT_BATCH_STATUS_CONTENT);
    sessionStorage.removeItem(STOCK_IN_BATCH_CONTENT);

    sessionStorage.removeItem(STOCK_IN_BATCH_STATUS_CONTENT);



    sessionStorage.removeItem(STOCK_OUT_EACH_CONTENT);

    sessionStorage.removeItem(STOCK_STOCK_CONTENT);

    sessionStorage.removeItem(STOCK_RECORD_CONTENT);


    sessionStorage.removeItem(STOCK_IN_EACH_CONTENT);


    sessionStorage.removeItem(STOCK_OUT_EACH_COUNT);


    sessionStorage.removeItem(GO_SHOP_ORDER_DETAIL);


    sessionStorage.removeItem(QA_REVIEW_TAB_STATUS);

    sessionStorage.removeItem(PURCHASE_ORDER_TAB_STATUS);

    sessionStorage.removeItem(PURCHASE_ORDER_PAYMENT_TAB_STATUS);




    sessionStorage.removeItem(PURCHASE_ORDER_ADDRESS);



    sessionStorage.removeItem(STORE_INFO_LOCAL);

    sessionStorage.removeItem(STOCK_OUT_EACH_SUPPLIER_CONTENT);


    sessionStorage.removeItem(SELECT_WAREHOUSE_ITEM);
    sessionStorage.removeItem(WAREHOUSE_SHOW_FLAG);







}





